import React from 'react';

// ── Types ─────────────────────────────────────────────────────────────────────

export type SaveFeedback = { ok: boolean; msg: string } | null;

export const CRITERES_TECHNIQUES = [
  { slug: 'description_humain', intitule: 'Présentation des moyens humains et matériels dédiés à la consultation', baremeKey: 'humain', baremeDefaut: 4, max: 3000, obligatoire: true },
  { slug: 'description_operationnel', intitule: 'Présentation des modes opératoires dédiés à la consultation', baremeKey: 'operationnel', baremeDefaut: 5, max: 3000, obligatoire: true },
  { slug: 'description_environnement', intitule: 'Présentation des mesures en matière environnementale et sociale dédiées à la consultation', baremeKey: 'environnement', baremeDefaut: 1, max: 3000, obligatoire: true },
] as const;

// Barèmes max par critère, configurés sur l'accord-cadre (sinon valeurs par défaut ci-dessus).
export interface BaremesTechniques {
  humain?: number;
  operationnel?: number;
  environnement?: number;
}

// ── Props ─────────────────────────────────────────────────────────────────────

interface SectionOffreTechniqueProps {
  poidsOffreTechnique: number;
  baremes?: BaremesTechniques;
  canEdit: boolean;
  offreTechnique: Record<string, string>;
  onChangeCritere: (slug: string, value: string) => void;
}

// ── Section "Offre technique" ─────────────────────────────────────────────────

const SectionOffreTechnique: React.FC<SectionOffreTechniqueProps> = ({
  poidsOffreTechnique,
  baremes,
  canEdit,
  offreTechnique,
  onChangeCritere,
}) => {
  return (
    <>
      <div className="section-content">
        {CRITERES_TECHNIQUES.map((critere) => {
          // Barème du critère : valeur configurée sur l'AC, sinon défaut métier (humain 4 / opératoire 5 / environnement 1).
          const bareme = baremes?.[critere.baremeKey] ?? critere.baremeDefaut;
          return (
            <div key={critere.slug} className="critere-block">
              <label className="critere-label">
                {critere.intitule} (sur {bareme} point{bareme > 1 ? 's' : ''})
                {critere.obligatoire && <span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>}
              </label>
              <textarea
                className={`critere-textarea${!canEdit ? ' critere-textarea-disabled' : ''}`}
                value={offreTechnique[critere.slug] ?? ''}
                onChange={(e) => onChangeCritere(critere.slug, e.target.value)}
                disabled={!canEdit}
                rows={6}
                maxLength={critere.max}
                placeholder="Votre réponse..."
              />
              <span className="char-counter">
                {(offreTechnique[critere.slug] ?? '').length} / {critere.max.toLocaleString('fr-FR')}
              </span>
            </div>
          );
        })}

      </div>
    </>
  );
};

export default SectionOffreTechnique;
